import script from "./ContentConfirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentConfirmation.vue?vue&type=script&setup=true&lang=ts"

import "./ContentConfirmation.vue?vue&type=style&index=0&id=3b5f15aa&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b5f15aa"]])

export default __exports__